import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { UserService } from "../../../@core/services/user.service";

import { Router } from "@angular/router";
import ReportSpam from "../../../models/report-spam.model";
import { DialogYesNoPromptComponent } from "../../../@components/dialog-yesno-prompt/dialog-yesno-prompt.component";

import { ReportSpamService } from "../../../services/report-spam.service";

@Component({
  selector: "ngx-view-reported",
  styleUrls: ["./view-reported.component.scss"],
  templateUrl: "./view-reported.component.html",
})
export class ViewReportedComponent implements OnInit {
  @Input() mode?: string = "admin"; //admin / develop
  @Input() reported: ReportSpam;
  @Input() isMore? = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  view = "main";
  uid = "";

  constructor(
    public userService: UserService,
    private reportService: ReportSpamService,
    private dialogService: NbDialogService,
    private router: Router
  ) {
    this.userService.getCurrentUser().subscribe((user) => {
      if (user && user.uid != this.uid) {
        this.uid = user.uid;
      } else {
        this.uid = "anonymous";
      }
    });
  }

  ngOnInit() {}

  reply() {
    this.view = "replies";
  }

  closeReply() {
    this.view = "main";
  }

  confirm(mode: string, item: ReportSpam) {
    let str = "";
    switch (mode) {
      case "hide":
        item.isActive = false;
        item.isConfirmed = false;
        item.isTrusted = false;
        str = "Đã xác nhận. Ẩn báo cáo này";
        break;
      case "yes":
        item.isConfirmed = true;
        item.isTrusted = true;
        str = "Đúng. Xóa bài viết này";
        break;
      case "no":
        item.isConfirmed = true;
        item.isTrusted = false;
        str = "Sai. Khôi phục lại bài viết";
        break;
      default:
        break;
    }

    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xác nhận trường hợp báo xấu này?",
          description: `Tôi đồng ý, trường hợp này là: ${str}!`,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.submitted = true;
          this.loading = true;

          this.reportService
            .confirm(item)
            .then((result) => {
              this.onDelete.emit(item.id);

              this.submitted = false;
              this.loading = false;
            })
            .catch((err) => {
              this.submitted = false;
              this.loading = false;
            });
        }
      });
  }

  loadContent(value) {
    this.isMore = value;
  }

  navigateRef(item) {
    if (item.navigateUrl != "") {
      this.router.navigateByUrl(item.navigateUrl);
    }
  }
}
